/**
 * @generated SignedSource<<1be83e8c28015f6b85f3a84fa77130d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NftAuctionStatus = "CANCELED" | "ENDED" | "LIVE" | "PAUSED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NftPdpLiveDetails_nftItem$data = {
  readonly balanceForUser?: {
    readonly balance: number | null;
  } | null;
  readonly contract: {
    readonly address: string | null;
  } | null;
  readonly creatorAddress: {
    readonly address: string | null;
  } | null;
  readonly isERC1155: boolean | null;
  readonly mostRecentAuction: {
    readonly auctionId: number | null;
    readonly fundsRecipient: {
      readonly " $fragmentSpreads": FragmentRefs<"NftPdpSplitComponent_address" | "SplitDetailsModal_address" | "useSplit_address">;
    } | null;
    readonly sellerAddress: {
      readonly address: string | null;
    } | null;
    readonly status: NftAuctionStatus | null;
    readonly winnerAddress: {
      readonly address: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"useBidPrices_nftAuction">;
  } | null;
  readonly paymentAddresses: {
    readonly " $fragmentSpreads": FragmentRefs<"NftPdpSplitComponent_paymentAddresses" | "SplitDetailsModal_paymentAddresses" | "useSplit_paymentAddresses">;
  } | null;
  readonly serviceId: string | null;
  readonly tokenId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpBidModal_nftItem" | "NftPdpPriceDisplay_nftItem" | "SplitDetailsModal_nftItem" | "useIsPrimarySale_nftItem" | "useMarketSettings_nftItem">;
  readonly " $fragmentType": "NftPdpLiveDetails_nftItem";
};
export type NftPdpLiveDetails_nftItem$key = {
  readonly " $data"?: NftPdpLiveDetails_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpLiveDetails_nftItem">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "address",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpLiveDetails_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tokenId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftTokenContract",
      "kind": "LinkedField",
      "name": "contract",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "creatorAddress",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PaymentAddresses",
      "kind": "LinkedField",
      "name": "paymentAddresses",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useSplit_paymentAddresses"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftPdpSplitComponent_paymentAddresses"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SplitDetailsModal_paymentAddresses"
        }
      ],
      "storageKey": null
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "NftItemBalance",
          "kind": "LinkedField",
          "name": "balanceForUser",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "balance",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftAuction",
      "kind": "LinkedField",
      "name": "mostRecentAuction",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "auctionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "sellerAddress",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "winnerAddress",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "fundsRecipient",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "useSplit_address"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NftPdpSplitComponent_address"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SplitDetailsModal_address"
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useBidPrices_nftAuction"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isERC1155",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpPriceDisplay_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpBidModal_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useIsPrimarySale_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SplitDetailsModal_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMarketSettings_nftItem"
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};
})();

(node as any).hash = "c2ef675814ea69af1fa29a0e67954b83";

export default node;
